<template>
  <div class="docproduct">
    <Header />
    <Banner />
    <AmsSolutionPage />
    <Footer />
  </div>
</template>

<script>
import Banner from '../components/Banner.vue'
import Footer from '../components/Footer.vue'
import Header from '@/components/Header.vue'
import AmsSolutionPage from '@/components/AmsSolutionPage.vue'

export default {
  name: 'docproduct',
  components: {
    AmsSolutionPage,
    Header,
    Banner,
    Footer,
  }
}
</script>

<style lang="scss">

</style>